import React from 'react'
import { Component as DonutChart } from "../ShadDonutChart";
import { addDays, eachWeekOfInterval, subDays } from "date-fns";

const desktopData = [
    { month: "january", desktop: 0, fill: "var(--color-january)" },
    { month: "february", desktop: 0, fill: "var(--color-february)" },
    { month: "march", desktop: 0, fill: "var(--color-march)" },
    { month: "april", desktop: 0, fill: "var(--color-april)" },
    { month: "may", desktop: 0, fill: "var(--color-may)" },
    { month: "june", desktop: 0, fill: "var(--color-june)" },
    { month: "july", desktop: 0, fill: "var(--color-july)" },
]

const chartConfig = {
    visitors: {
        label: "Visitors",
    },
    desktop: {
        label: "Desktop",
    },
    mobile: {
        label: "Mobile",
    },
    january: {
        label: "January",
        color: "hsl(var(--chart-1))",
    },
    february: {
        label: "February",
        color: "hsl(var(--chart-2))",
    },
    march: {
        label: "March",
        color: "hsl(var(--chart-3))",
    },
    april: {
        label: "April",
        color: "hsl(var(--chart-4))",
    },
    may: {
        label: "May",
        color: "hsl(var(--chart-5))",
    },
    june: {
        label: "June",
        color: "hsl(var(--chart-6))",
    },
    july: {
        label: "July",
        color: "hsl(var(--chart-7))",
    },
}

const locationHebrewName = {
    "KURSI_BEACH": "חוף כורסי",
    "SHIKMIM": "חוף שיקמים",
    "TSINBERI": "חוף צינברי",
}

function YsbDonutChart({ data, deviceNames, donutDeviceName, setDonutDeviceName }) {
    console.log(deviceNames, data, data.length, desktopData[desktopData.length - 1].desktop, "deviceNames");

    const { timeZone, locale } = Intl.DateTimeFormat().resolvedOptions();

    const dateRangeSundays = eachWeekOfInterval({
        start: new Date(new Date(data[0].date).toLocaleString('en-us', {timeZone: 'Asia/Jerusalem'})),
        end: new Date(new Date(data[data.length - 1].date).toLocaleString('en-us', {timeZone: 'Asia/Jerusalem'}))
    });

    let lastSundayDate = dateRangeSundays[dateRangeSundays.length - 2];

    let lastToLastSundayDate = dateRangeSundays[dateRangeSundays.length - 3];

    let lastSaturdayDate = subDays(dateRangeSundays[dateRangeSundays.length - 1], 1);

    let lastToLastSaturdayDate = subDays(dateRangeSundays[dateRangeSundays.length - 2], 1);



    const result = data.reduce((acc, curr) => {
        const dateOnly = curr.date.split("T")[0]; // Extract the date part (YYYY-MM-DD)
        const occupancyValue = ((acc[dateOnly] || 0) + curr.entering) /* - ((acc[dateOnly] || 0) + curr.leaving) */
        acc[dateOnly] = occupancyValue < 0 ? 0 : occupancyValue ; // Sum up "entering"
        return acc;
    }, {});

    console.log(result, "resulta");



    const formattedResult = Object.entries(result).map(([date, enteringSum]) => ({
        date,
        enteringSum
    }));

    console.log(formattedResult, formattedResult.length, "result");

    formattedResult.slice(formattedResult.findIndex(fr => new Date(fr.date).getDate() === new Date(lastSundayDate).getDate()), formattedResult.findIndex(fr => new Date(fr.date).getDate() === new Date(addDays(lastSaturdayDate, 1)).getDate())).forEach((element, i) => {

        desktopData[i].month = new Date(element.date).toLocaleString('he-us', { day: 'numeric', month: 'short', weekday: 'short' });

        desktopData[i].desktop = element.enteringSum;

    });

    const currentWeekValue = desktopData.reduce((acc, item) => acc + item.desktop, 0);
    const lastWeekValue = formattedResult.slice(formattedResult.findIndex(fr => new Date(fr.date).getDate() === new Date(lastToLastSundayDate).getDate()), formattedResult.findIndex(fr => new Date(fr.date).getDate() === new Date(addDays(lastToLastSaturdayDate, 1)).getDate())).reduce((acc, item) => acc + item.enteringSum, 0);
    const weeklyDifference = currentWeekValue - lastWeekValue;
    console.log(desktopData, lastWeekValue, currentWeekValue, "desktopData");

    const id = "pie-interactive"
    const [activeMonth, setActiveMonth] = React.useState(deviceNames[0])

    const activeIndex = React.useMemo(
        () => desktopData.findIndex((item) => item.month === activeMonth),
        [activeMonth]
    )
    const months = React.useMemo(() => deviceNames.map((item) => item), [])

    return (
        <DonutChart
            weeklyDifference={weeklyDifference}
            desktopData={desktopData}
            chartConfig={chartConfig}
            locationHebrewName={locationHebrewName}
            deviceNames={deviceNames}
            setDonutDeviceName={setDonutDeviceName}
            donutDeviceName={donutDeviceName}
            currentWeekValue={currentWeekValue}
        />
    )
}

export default YsbDonutChart